import { createSelector } from 'reselect';
import _, {
    map, filter, has, pick, values, isEmpty, get, groupBy, find,
} from 'lodash';
import { CONSTANTS } from 'services/constants';
import { buildRequestByReservationIdSelector } from './requests.selector';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntityIds = (state, ids) => ids;
const getEntities = (state) => get(state, 'app.database.hotels', {});
const getMetaEntities = (state) => get(state, 'app.metaDatabase.hotels', {});

/**
 * Selector Builders
 */
export const buildMetaHotelSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildMetaHotelsSelector = () => createSelector([getEntityIds, getMetaEntities], (entityIds, metaEntities) => _.values(metaEntities ?? []).filter((entity) => _.includes(entityIds, entity.id)));

export const buildHotelSelector = () => createSelector([getEntityId, getEntities], (entityId, entities) => entities.find((entity) => entityId === entity.id));

export const buildHotelsSelector = () => createSelector([getEntityIds, getEntities], (entityIds, entities) => _.values(entities)?.filter((entity) => _.includes(entityIds, entity.id)));
